import { type FC } from "react";
import { Button } from "../../components/ui/button";
import { gluceraAuthCta } from "../../utils/gluceraTypography";
import { Footprints, Heart, Moon, Zap } from "lucide-react";
import BrandLogo from "../../components/BrandLogo";
import { useNavigate } from "react-router-dom";
import fitbitAuthService from "../../services/FitbitAuthService";


import { notify } from "@/components/common/Notification";


const FitbitConnectionPage: FC = () => {
  const navigate = useNavigate();



  const handleConnectNow = async () => {
    await fitbitAuthService.loginRedirect((err: string) => {
      notify.error(err);
    });
  };

  const benefits = [
    { icon: Footprints, text: "Track daily steps & activity" },
    { icon: Heart, text: "Monitor heart rate & calories" },
    { icon: Moon, text: "Analyze sleep quality" },
    { icon: Zap, text: "Optimize workout performance" },
  ];

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Content */}
        <div className="flex-1 overflow-y-auto px-4 py-4 sm:px-6 sm:py-8">
          <div className="flex flex-col items-center space-y-4 text-center sm:space-y-6">
            <BrandLogo variant="hero" showWordmark={false} className="sm:gap-0" />

            {/* Heading */}
            <h1 className="text-title1 font-bold text-foreground sm:text-large-title">
              Connect Your Fitbit
            </h1>

            {/* Description */}
            <p className="max-w-sm text-caption1 text-muted-foreground sm:text-subhead">
              We'll use it to track steps, heart rate, sleep, and exercise to
              give you better Bite Balance predictions.
            </p>

            {/* Benefits List */}
            <div className="w-full space-y-3 pt-4">
              {benefits.map((benefit, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-3 rounded-lg border border-border bg-card p-3"
                >
                  <benefit.icon className="h-5 w-5 flex-shrink-0 text-primary" />
                  <span className="text-subhead text-foreground">
                    {benefit.text}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="pb-safe space-y-2 p-4 sm:space-y-3">
          <Button
            type="button"
            onClick={handleConnectNow}
            className={gluceraAuthCta}
          >
            Yes, Connect Now
          </Button>
          <button
            onClick={() => navigate("/glucera/homepage")}
            className="w-full py-2 text-center text-caption1 text-foreground transition-colors hover:text-primary sm:text-subhead"
          >
            Not Now
          </button>

        </div>
      </div>
    </div>
  );
};

export default FitbitConnectionPage;
